import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonSharedService {
  private fileUploadUrl = new BehaviorSubject('');
  private tFaModal = new BehaviorSubject(false);
  private tFaVerificationModal = new BehaviorSubject(false);

  constructor() {}

  getFileUploadUrl(): Observable<string> {
    return this.fileUploadUrl.asObservable();
  }

  setFileUploadUrl(url: string) {
    this.fileUploadUrl.next(url);
  }

  get2FAModal(): Observable<boolean> {
    return this.tFaModal.asObservable();
  }

  setF2FAModal(url: boolean) {
    this.tFaModal.next(url);
  }
  get2FAVerificationModal(): Observable<boolean> {
    return this.tFaVerificationModal.asObservable();
  }

  setF2FAVetificationModal(url: boolean) {
    this.tFaVerificationModal.next(url);
  }
}
